export const FETCH_APPLINK_FAILURE =
	'state.actions.fetch-applink-failure.FETCH_APPLINK_FAILURE' as const;

export type FetchAppLinkFailurePayload = {
	statusCode: number;
};

export type FetchAppLinkFailureAction = {
	type: typeof FETCH_APPLINK_FAILURE;
	payload: FetchAppLinkFailurePayload;
};

export const fetchAppLinkFailure = (
	error: FetchAppLinkFailurePayload,
): FetchAppLinkFailureAction => ({
	type: FETCH_APPLINK_FAILURE,
	payload: error,
});
